import { trackEvent } from "./helpers";

// Get story data from GUID
const getStoryData = async ({ id, country, StoriesAzureAPI, debug, getVenueName, setState, state }) => {
  // Get story data depending on url (USA is using a slightly differnt system which requires a different call)
  let story;
  if (country === "us") {
    story = await await StoriesAzureAPI.get("GetStoryData", {
      params: { id: id },
    }).then((response) => {
      if (debug) console.log("API request response:", response);
      return response;
    });
  } else {
    story = await await StoriesAzureAPI.get(id).then((response) => {
      if (debug) console.log("API request response:", response);
      return response;
    });
  }
  // Handle 204 - story has been deleted
  if (story.status === 204) {
    setState({ ...state, guid: id, deleted: true });
    return;
  }

  // After raw Story data has been pulled we trigger getVenueName
  let venue = getVenueName(story.data.venue_code);

  // let data = story.data.Newsfeed.filter((newsfeed) => newsfeed.type === 14)
  // console.log(data);
  // console.log(story.data.Newsfeed, "data");

  function parsePlayerEvents(story) {
    const playersRaw = story.data.Players;
    const newsfeedRaw = story.data.Newsfeed;

    // array of player objects
    const playersList = playersRaw.map((player) => ({
      id: player.id,
      name: player.name,
      points: player.points,
      gold: player.gold,
      silver: player.silver,
      bronze: player.bronze,
      events: [],
      photo: player.photo,
      final_result: player.final_result,
    }));

    // assign events to players by matching IDs from newsfeed
    newsfeedRaw.forEach((news) => {
      const newsPlayers = news.players;
      if (!newsPlayers) return;

      const playerIds = Array.isArray(newsPlayers) ? newsPlayers : [newsPlayers];

      playerIds.forEach((pidStr) => {
        const pid = parseInt(pidStr, 10);
        const player = playersList.find((p) => p.id === pid);
        if (player) {
          player.events.push(news);
        }
      });
    });

    // Sort players from highest to lowest points, breaking ties by gold, then silver, then bronze
    playersList.sort((a, b) => {
      if (b.points !== a.points) {
        return b.points - a.points; // primary sort: points
      }
      if (b.gold !== a.gold) {
        return b.gold - a.gold; // tiebreaker 1: gold
      }
      if (b.silver !== a.silver) {
        return b.silver - a.silver; // tiebreaker 2: silver
      }
      return b.bronze - a.bronze; // tiebreaker 3: bronze
    });

    return playersList;
  }

  // Get all events from story and sort them into different arrays for photos, loopcams, actionreplays and games
  let events = story.data.Newsfeed.reduce(
    (data, event) => {
      const uriExists = event.asset_uri?.trim() !== "";

      if (event.type === 201) {
        // Event 201 - Photo. If Uri exists add it to array
        if (uriExists) {
          data.photos.push(event);
        }
      } else if (event.type === 200) {
        // Event 200 - Loopcam. If Uri exists add it to array
        if (uriExists) {
          data.loopcams.push(event);
        }
      } else if (event.type >= 100 && event.type <= 150) {
        // Event between 100 - 150 - Action Replay. if Uri exits add it to array
        if (uriExists) {
          data.actionReplays.push(event);
        }
      } else if (event.type >= 1 && event.type <= 33) {
        // Event 1- 30 Game Events.
        // CHeck for event 1(Game start) Add as new game type to game object. This only lets there be one object for each game type
        if (event.type === 1) {
          if (!(event.game in data.games)) {
            data.games[event.game] = [];
          }
        }
        // add each game event to the relevent game type object
        data.games[event.game].push(event);
      }
      return data;
    },
    {
      actionReplays: [],
      loopcams: [],
      photos: [],
      games: {},
    },
  );

  //set up array for game events
  let gameEvents = [];
  //loop through each game type from games object
  for (let [key, game] of Object.entries(events.games)) {
    //console.log(key, game)
    // set highscor var to black at the start of each loop
    let highscore;
    // switch to do different array manipulation dependant on game type
    switch (key) {
      case "DEMOLITION":
        // map array to be value of info if event is type 2 (High 3 dart score) otherwise set it to 0
        // use math max apply to new array to get the highest value.
        highscore = Math.max.apply(
          null,
          game.map(function (o) {
            if (o.type == 2) {
              return +o.info;
            } else {
              return 0;
            }
          }),
        );
        if (highscore != 0) {
          // if high score exists get full event object and if a player exists in that object add it to the game events array
          let obj = game.find(function (o) {
            return o.info == highscore;
          });
          if (obj.players) {
            gameEvents.push(obj);
          }
        }
        break;
      case "SHANGHAI":
        // map array to be value of info(1st in list * 2nd item in list) if event is type 9 (High 3 dart score) otherwise set it to 0
        // use math max apply to new array to get the highest value.
        highscore = Math.max.apply(
          null,
          game.map(function (o) {
            if (o.type == 9) {
              return +o.info.split(",")[0] * +o.info.split(",")[1];
            } else {
              return 0;
            }
          }),
        );
        if (highscore != 0) {
          // if high score exists get full event object and if a player exists in that object add it to the game events array
          let obj = game.find(function (o) {
            return +o.info.split(",")[0] * +o.info.split(",")[1] == highscore;
          });
          if (obj.players) {
            gameEvents.push(obj);
          }
        }
        break;
      case "QUACKSHOT":
        //Creating new array with player and player score(info). reduce will loop through each item in array and check for the score
        let duckScore = game.reduce((r, { players, info, type }) => {
          // Look for event 10 (Bulleye's)
          if (type == 10) {
            //Look for player in new socre array
            var temp = r.find((o) => o.players === players);
            //if player exists add this score to the existing socre
            if (temp) {
              temp.info += info.split(",").reduce((a, b) => +a + +b);
            } else {
              // if player doesnt exist in new array yet5 add it in
              let score = info.split(",").reduce((a, b) => +a + +b);
              if (players) {
                r.push({ players, info: score });
              }
            }
          }
          return r;
        }, []);
        // If there are any bullseye scores find highest by loopong through the array via reduce and comparing current score to current max
        if (duckScore.length)
          highscore = duckScore.reduce((max, score) => (max.info > score.info ? max : score));
        if (highscore) {
          // if a highscore exists find player details and add to game events array
          let obj = game.find(function (o) {
            return o.players === highscore.players;
          });
          gameEvents.push(obj);
        }
        break;
      case "KILLER":
        //Creating new array with player abd kill count. reduce will loop through each item in array and check for kill events
        let killScore = game.reduce((r, { players, type }) => {
          //Look for event type 13 (Kill event)
          if (type == 13) {
            //check new array to see if playe already exists. Iff they do increase kill count by one
            var temp = r.find((o) => o.players === players);
            if (temp) {
              temp.count++;
            } else {
              // if player doesnt exist add them to arry with count of one
              let score = 1;
              r.push({ players, count: score });
            }
          }
          return r;
        }, []);
        // If there are any Kills find highest by loopong through the array via reduce and comparing current score to current max
        if (killScore.length)
          highscore = killScore.reduce((max, score) => (max.count > score.count ? max : score));
        if (highscore) {
          // if a highscore exists find player details and add to game events array
          let obj = game.find(function (o) {
            return o.players === highscore.players;
          });
          gameEvents.push(obj);
        }
        break;
      case "SNAKESANDLADDERS":
        //Creating new array with player and snake count. reduce will loop through each item in array and check for Snake events
        let snakeScore = game.reduce((r, { players, type }) => {
          //Look for event type 15 (Snake event)
          if (type == 15) {
            //check new array to see if playe already exists. If they do increase snake count by one
            var temp = r.find((o) => o.players === players);
            if (temp) {
              temp.count++;
            } else {
              // if player doesnt exist add them to array with count of one
              let score = 1;
              r.push({ players, count: score });
            }
          }
          return r;
        }, []);
        // If there are any snake evtns find highest by looping through the array via reduce and comparing current score to current max
        if (snakeScore.length)
          highscore = snakeScore.reduce((max, score) => (max.count > score.count ? max : score));
        if (highscore) {
          // if a highscore exists find player details and add to game events array
          let obj = game.find(function (o) {
            return o.players === highscore.players;
          });
          gameEvents.push(obj);
        }
        break;
      case "DONKEYDERBY":
        // code block
        break;
      case "LIMBO":
        // Step 1: Build an array of players and their lowest LIMBO score (type 31)
        let limboScore = game.reduce((r, { players, type, info }) => {
          if (type === 31) {
            // Check if player is already in result array
            let existing = r.find((p) => p.players === players);
            if (existing) {
              // Update if this score is lower
              if (+info < +existing.score) {
                existing.score = +info;
              }
            } else {
              // New player, add with initial score
              r.push({ players, score: +info });
            }
          }
          return r;
        }, []);

        // Step 2: Find the player with the lowest score
        if (limboScore.length) {
          highscore = limboScore.reduce((min, p) => (min.score < p.score ? min : p));

          // Step 3: Push the full event object for that player and score
          let obj = game.find((o) => o.players === highscore.players && +o.info === highscore.score);
          if (obj) gameEvents.push(obj);
        }

        break;

      default:
        // default
        break;
    }
  }

  const parsedPlayers = parsePlayerEvents(story);

  // Set state variables to story data and event data
  setState({
    ...state,
    guid: id,
    type: story.data.type,
    reference: story.data.reference,
    date: story.data.date,
    country: country,
    venue: venue.venue_name,
    city: venue.city_name,
    cityurl: venue.city_url,
    bloburl: venue.blob_url,
    azureurl: venue.azure_url,
    videourl: venue.video_url,
    feedbackurl: venue.feedback_url,
    googleurl: venue.google_url,
    players: story.data.Players,
    parsedPlayers: parsedPlayers,
    teams: story.data.Teams,
    newsfeed: story.data.Newsfeed,
    photos: events.photos,
    // actionReplays:
    //   story.data.type == "1" || story.data.type == "3"
    //     ? events.actionReplays
    //         .slice(
    //           events.actionReplays.length - 10 < 0 ? 0 : events.actionReplays.length - 10,
    //           events.actionReplays.length,
    //         )
    //         .reverse()
    //     : events.actionReplays,
    actionReplays: events.actionReplays,
    loopcams: events.loopcams,
    games: gameEvents,
    debug: debug,
    oche: story.data.oches,
  });
  // Google analytics trigger open story event
  trackEvent("Story opened", "s: " + window.location.host + " v: " + venue.venue_name);
};

export default getStoryData;
